import { LeaderboardUser, LeaderboardUserBase } from "./LeaderboardUser";

export type SegmentLeaderboardUser = LeaderboardUserBase & {
  parts: LeaderboardPart[];
};

export const isSegmentLeaderboardUser = (
  user: LeaderboardUser
): user is SegmentLeaderboardUser => {
  return (user as SegmentLeaderboardUser).parts !== undefined;
};

export type LeaderboardPart = {
  pickemId: string;
  points: { [id: string]: number };
  driverPoints?: { [driverId: string]: number };
};

export const sumLeaderboardPartPoints = (part: LeaderboardPart | undefined) => {
  if (!part) {
    return undefined;
  }

  const pointsTotal = Object.values(part.points).reduce((a, b) => a + b, 0);
  const driverPointsTotal = !!part.driverPoints
    ? Object.values(part.driverPoints).reduce((a, b) => a + b, 0)
    : 0;

  return pointsTotal + driverPointsTotal;
};
